// checkin_template_id
const BwPlace = (place) => {
	const address = place?.formatted_address || place?.address || null;
	const description = place?.description || null;
	const google_place_id = place?.place_id || null;
	const google_place_types = place?.types || null;
	const id = place?.id || null;
	const latitude = place?.geometry?.location?.lat || null;
	const longitude = place?.geometry?.location?.lng || null;
	const media = place?.media || null;
	const name = place?.name || null;
	const phone = place?.formatted_phone_number || place?.phone || null;
	const website = place?.website || null;

	return {
		address,
		description,
		google_place_id,
		google_place_types,
		id,
		latitude,
		longitude,
		media,
		name,
		phone,
		website
	};
};

const Place = (place) => {
	// If we have place media we want the Header first
	if(place) {
		place.media = place.deal_venue?.media?.filter(media => media.location === 'Header')
				|| place.media?.filter(media => media.location === 'Header')
				|| [];
	}

	const description = place?.deal_venue?.description || place?.description || null;
	const formatted_address = place?.formatted_address || place?.address || null;
	const formatted_phone_number = place?.formatted_phone_number || place?.phone || null;
	const geometry = place?.geometry || {
		location: {
			lat: isNaN(parseFloat(place?.latitude)) ? null : parseFloat(place?.latitude),
			lng: isNaN(parseFloat(place?.longitude)) ? null : parseFloat(place?.longitude)
		}
	};

	const id = place?.id || null;
	const name = place?.name || null;
	const place_id = place?.place_id || place?.google_place_id || null;
	const types = place?.types || place?.google_place_types || ['point_of_interest'];
	const media = place?.media?.length && place.media || [
		{
			cropperSettings: {
				limitAR: '2:1',
				x: 0,
				y: 0
			},
			location: 'Header',
			minDimensions: '640x320',
			name: 'Header',
			url: '/images/placehold.co.png'
		}
	];
	const website = place?.website || null;

	// Delete some keys that can cause app confusion
	if(place) {
		delete place.address;
		delete place.phone;
		delete place.latitude;
		delete place.longitude;
		delete place.google_place_id;
		delete place.google_place_types;
	}

	// Add any other keys from the provided place
	if(place) {
		for (let key in place) {
			if(!this.hasOwnProperty(key)) {
				this[key] = place[key];
			}
		}
	}

	return {
		description,
		formatted_address,
		formatted_phone_number,
		geometry,
		id,
		name,
		place_id,
		types,
		media,
		website,
		...place
	};
};

const Campaign = (campaign) => {
	const defaultCampaign = {
		deal_id: 0,
		description: null,

		// Including these will break the merge in the backend. New campaigns will not get
		// their `email_settings` from the template in this case.

		// email_settings: {
		// 	dripSequences: [
		// 		{
		// 			activationDate: null
		// 		}
		// 	],
		// 	inviteMessage: []
		// },

		name: null,
		offer_id: 0,
		onboard_settings: {
			autoAddCheckIn: false,
			tos_form: null,
			productReqs: [],
			venue_template: null
		},
		setup_settings: null,
		template_id: 0,
		venueIds: [],
		venues: []
	};

	// Customizer function to handle merging
	const customizer = (objValue, srcValue, key) => {
		if(key === 'dripSequences' && Array.isArray(srcValue) && srcValue.length === 0) {
			// If dripSequences is an empty array, return the default non-empty array
			return objValue;
		}
	};

	// Perform a deep merge with the customizer to handle specific cases
	return mergeWith({}, defaultCampaign, campaign, customizer);
};

const OnboardSettings = (settings) => {
	const defaultSettings = {
		tos_form: null,
		user_form: null,
		venue_form: null,
		productReqs: [],
		autoAddCheckIn: false,
		venue_template: null,
		checkin_template: null,
		checkin_template_id: null
	};

	// Override default settings with provided settings
	return { ...defaultSettings, ...settings };
};

const ProductReq = (req) => {
	const defaultReq = {
		child_templates: [],
		limit_child_templates: false,
		min: null,
		product_instructions: null,
		product_template: null,
		product_template_name: null,
		product_template_type: null,
		product_title: null
	};

	return { ...defaultReq, ...req };
};


export {
	BwPlace,
	Campaign,
	OnboardSettings,
	Place,
	ProductReq
};